export default __webpack_public_path__ + "static/media/39-Rexel.112640c3.jpg";